module.exports = __webpack_public_path__ + "static/img/ESG_2025.49db4d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/ESG_2025.jpg
// module id = TDDW
// module chunks = 98